
import { Injectable, inject } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Injectable({
    providedIn: "root"
})
export class RaskTitleService {
    private readonly title = inject(Title);

    setTitle(title: string) {
        const currentTitle = this.title.getTitle();
        const res = currentTitle.split("-");
        const prefix = res[1] || ` ${res[0]}`;
        this.title.setTitle(`${title} -${prefix}`);
    }
}
